import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Alert } from '@mui/material';
import { WalteroCard, WalteroTypography } from './waltero';
import { hasOrganizationAccess } from '../utils/auth';
import { ADMIN_ORGANIZATION_ID } from '../config/api';

// Import subscription management components (to be created)
import SubscriptionOverview from './subscriptions/SubscriptionOverview';
import SubscriptionTypes from './subscriptions/SubscriptionTypes';
import OrganizationSubscriptions from './subscriptions/OrganizationSubscriptions';
import SensorAssignments from './subscriptions/SensorAssignments';

const SubscriptionTab = () => {
  const [activeTab, setActiveTab] = useState('overview');

  // Admin access check - early return if not admin
  if (!hasOrganizationAccess(ADMIN_ORGANIZATION_ID)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning" sx={{ mb: 3 }}>
          <strong>Admin Access Required</strong>
          <br />
          You need administrator privileges to access subscription management.
        </Alert>
      </Box>
    );
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      <WalteroCard sx={{ mb: 3 }}>
        <Box sx={{ p: 3 }}>
          <WalteroTypography 
            variant="h4" 
            sx={{ 
              mb: 1, 
              color: 'waltero.primary.coreBlue',
              fontWeight: 700
            }}
          >
            Subscription Management
          </WalteroTypography>
          <WalteroTypography 
            variant="body1" 
            sx={{ 
              mb: 3,
              color: 'text.secondary'
            }}
          >
            Manage subscription types, organization assignments, and sensor subscriptions.
          </WalteroTypography>

          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: 'waltero.primary.coreBlue',
              },
              '& .MuiTab-root': {
                color: 'text.secondary',
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 500,
                '&.Mui-selected': {
                  color: 'waltero.primary.coreBlue',
                  fontWeight: 600,
                },
              },
            }}
          >
            <Tab label="Overview" value="overview" />
            <Tab label="Subscription Types" value="types" />
            <Tab label="Organization Subscriptions" value="organizations" />
            <Tab label="Sensor Assignments" value="sensors" />
          </Tabs>
        </Box>
      </WalteroCard>

      {/* Tab Content */}
      <Box>
        {activeTab === 'overview' && <SubscriptionOverview />}
        {activeTab === 'types' && <SubscriptionTypes />}
        {activeTab === 'organizations' && <OrganizationSubscriptions />}
        {activeTab === 'sensors' && <SensorAssignments />}
      </Box>
    </Box>
  );
};

export default SubscriptionTab;